import { Columns3, List, CalendarDays } from 'lucide-react';
import type { ViewType } from '../../types';
import { useApp } from '../../context/AppContext';

const views: { type: ViewType; icon: React.ElementType; label: string }[] = [
  { type: 'kanban', icon: Columns3, label: 'Kanban' },
  { type: 'list', icon: List, label: 'Lista' },
  { type: 'calendar', icon: CalendarDays, label: 'Calendário' },
];

export default function ViewToggle() {
  const { state, dispatch } = useApp();

  return (
    <div className="inline-flex rounded-xl bg-slate-100 p-1" role="tablist" aria-label="View type">
      {views.map(({ type, icon: Icon, label }) => {
        const active = state.currentView === type;
        return (
          <button
            key={type}
            onClick={() => dispatch({ type: 'SET_VIEW', payload: type })}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 ${
              active
                ? 'bg-white text-brand-600 shadow-sm'
                : 'text-slate-500 hover:text-slate-700'
            }`}
            role="tab"
            aria-selected={active}
            aria-label={label}
          >
            <Icon size={16} />
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
